import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"#31344A\" fill-rule=\"evenodd\" clip-path=\"url(#i462665788__a)\" clip-rule=\"evenodd\"><path d=\"M11 5.5a3.143 3.143 0 1 0 0 6.286A3.143 3.143 0 0 0 11 5.5ZM6.286 8.643a4.714 4.714 0 1 1 9.428 0 4.714 4.714 0 0 1-9.428 0Z\"></path><path d=\"M11 15.716a7.071 7.071 0 0 0-6.039 3.393.786.786 0 1 1-1.342-.818 8.643 8.643 0 0 1 14.762 0 .786.786 0 1 1-1.342.818A7.07 7.07 0 0 0 11 15.716Z\"></path><path d=\"M11 1.571a9.429 9.429 0 1 0 0 18.858A9.429 9.429 0 0 0 11 1.57ZM0 11C0 4.925 4.925 0 11 0s11 4.925 11 11-4.925 11-11 11S0 17.075 0 11Z\"></path></g><defs><clipPath id=\"i462665788__a\"><path fill=\"#fff\" d=\"M0 0h22v22H0z\"></path></clipPath></defs>", 2)
  ])))
}
export default { render: render }